import * as actionTypes from "./actionTypes";

export const fetchCurrentLocationSuccess = (position) => {
  return {
    type: actionTypes.FETCH_CURRENT_LOCATION_SUCCESS,
    position: {
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
    },
  };
};
export const fetchCurrentLocationFailed = (error) => {
  return {
    type: actionTypes.FETCH_CURRENT_LOCATION_FAILED,
    payload: error,
  };
};

export const resetCurrentLocation = () => {
  return {
    type: actionTypes.RESET_CURRENT_LOCATION,
  };
};

export const fetchCurrentLocation = () => {
  return (dispatch) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          dispatch(fetchCurrentLocationSuccess(position));
        },
        (error) => {
          dispatch(fetchCurrentLocationFailed(error));
        }
      );
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  };
};
